import { IconButton, Tooltip } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { tokens } from '@synergy/theme-palo';

export interface PaloIconRowAction {
    label: ReactNode;
    onClick: () => void;
    disabled?: boolean;
    /** Why it cannot be used, shown on hover while it is disabled. */
    reason?: ReactNode;
    /** Lets the action stand in the row itself while it is the row's only one. */
    icon?: ReactNode;
}

/**
 * The action a row shows as its symbol: its only one, if it has a symbol. A
 * menu with a single entry costs a click for nothing; from two actions on, the
 * row keeps its "…" (LST-S17, #2341).
 */
export const paloSoleIconAction = <A extends PaloIconRowAction>(actions: A[]): A | undefined =>
    1 === actions.length && actions[0].icon ? actions[0] : undefined;

export const PaloRowActionButton = ({ action }: { action: PaloIconRowAction }): ReactElement => (
    // A disabled button answers no mouse, so the tooltip hangs on a wrapper.
    <Tooltip title={action.disabled && action.reason ? action.reason : action.label}>
        <span>
            <IconButton
                size="small"
                disabled={action.disabled}
                onClick={action.onClick}
                sx={{ color: tokens.color.accent, '&.Mui-disabled': { color: tokens.color.ink3 } }}
            >
                {action.icon}
            </IconButton>
        </span>
    </Tooltip>
);
